// api_error_samples.js
// Minimal API endpoint -> backend error substring -> humanized message mapping
// Intended for use by form components to show inline sonar hints and toasts.

import { match } from "stylis";

export const apiErrorMappings = [
    {
        endpoint: "api/clinic/addClinic",
        errors: [
            { match: "no fields to update", human: "No changes were provided to save.", field: null },
            { match: "clinic_name is required", human: "Please enter the clinic name.", field: "clinic_name" },
            { match: "clinic email already in use", human: "This clinic email is already registered. Use a different email.", field: "email" },
            { match: "clinic phone already in use", human: "This phone number is already registered for another clinic.", field: "phoneno" },
            { match: "something went wrong", human: "Could not create clinic. Try again or contact support.", field: null }
        ]
    },
    {
        endpoint: "api/frontdesk/register",
        errors: [
            { match: "invalid token", human: "Authentication failed — please login again.", field: null },
            { match: "email already in use", human: "This email is already registered. ", field: "email" },
            { match: "phone already in use", human: "This phone number is already registered. Use a different number.", field: "phoneno" },
            { match: "duplicate", human: "A record with similar details already exists.", field: null },
            { match: "something went wrong", human: "Could not register frontdesk. Try again or contact support.", field: null }
        ]
    },
    {
        endpoint: "api/doctor/register",
        errors: [
            { match: "invalid token", human: "Authentication failed — please login again.", field: null },
            { match: "email already in use", human: "This email is already registered. Use a different email.", field: "email" },
            { match: "phone already in use", human: "This phone number is already registered. Use a different number.", field: "whatsapp_no" },
            { match: "medical license", human: "This medical license number is already registered.", field: "medical_license" },
            { match: "duplicate", human: "A doctor with similar details already exists.", field: null },
            { match: "something went wrong", human: "Could not register doctor. Try again or contact support.", field: null }
        ]
    },
    {
        endpoint: "api/doctor/update",
        errors: [
            { match: "invalid token", human: "Authentication failed — please login again.", field: null },
            { match: "email already in use", human: "This email is used by another doctor. Use a different email.", field: "email" },
            { match: "phone already in use", human: "This phone number is used by another doctor.", field: "whatsapp_no" },
            { match: "medical license", human: "This medical license number is already registered.", field: "medical_license" },
            { match: "something went wrong", human: "Could not update doctor. Try again or contact support.", field: null }
        ]
    },
    {
        endpoint: "api/clinic",
        errors: [
            { match: "Clinic phone number already in use", human: "This phone number is already registered for another clinic.", field: "phoneno" },
            { match: "Clinic email already in use", human: "This clinic email is already registered. Use a different email.", field: "email" },
            { match: "No fields to update", human: "No changes were provided to save.", field: null },
            { match: "Something went wrong", human: "Could not create clinic. Try again or contact support.", field: null }
        ]
    },
    {
        endpoint: "api/frontdesk",
        errors: [
            { match: "Email already in use", human: "This email is already registered. ", field: "email" },
            { match: "Front Desk with this email already exists", human: "This email is already registered. ", field: "email" }]
    }
];
export function humanizeApiError(endpoint, backendMessage) {
    if (!backendMessage) return { message: 'Server error', field: null };

    // Normalize endpoint: remove leading slashes and lowercase
    const normalized = String(endpoint || '').replace(/^\/+/, '').toLowerCase();
    const msg = String(backendMessage).toLowerCase();

    const map = apiErrorMappings.find(m => m.endpoint.toLowerCase() === normalized);
    if (!map) return { message: backendMessage, field: null };

    for (const err of map.errors) {
        if (msg.includes(err.match.toLowerCase())) {
            return { message: err.human, field: err.field };
        }
    }

    const fallback = map.errors.find(e => e.match.toLowerCase().includes('something went wrong'));
    return { message: fallback ? fallback.human : backendMessage, field: null };
}

export default apiErrorMappings;
